module.exports = __webpack_public_path__ + "img/5.b454f56d.png";